/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
} from './Document';
import type { HchbPatientDetailsDocumentsAdditionalDocumentsInner } from './HchbPatientDetailsDocumentsAdditionalDocumentsInner';
import {
    HchbPatientDetailsDocumentsAdditionalDocumentsInnerFromJSON,
    HchbPatientDetailsDocumentsAdditionalDocumentsInnerFromJSONTyped,
    HchbPatientDetailsDocumentsAdditionalDocumentsInnerToJSON,
} from './HchbPatientDetailsDocumentsAdditionalDocumentsInner';
import type { HchbPatientDetailsDocumentsGeneratedDocumentsInner } from './HchbPatientDetailsDocumentsGeneratedDocumentsInner';
import {
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSON,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerToJSON,
} from './HchbPatientDetailsDocumentsGeneratedDocumentsInner';

/**
 * 
 * @export
 * @interface HchbPatientDetailsDocuments
 */
export interface HchbPatientDetailsDocuments {
    /**
     * 
     * @type {Array<HchbPatientDetailsDocumentsGeneratedDocumentsInner>}
     * @memberof HchbPatientDetailsDocuments
     */
    generated_documents?: Array<HchbPatientDetailsDocumentsGeneratedDocumentsInner>;
    /**
     * 
     * @type {Array<Document>}
     * @memberof HchbPatientDetailsDocuments
     */
    screener_documents?: Array<Document>;
    /**
     * 
     * @type {Array<HchbPatientDetailsDocumentsAdditionalDocumentsInner>}
     * @memberof HchbPatientDetailsDocuments
     */
    additional_documents?: Array<HchbPatientDetailsDocumentsAdditionalDocumentsInner>;
}

/**
 * Check if a given object implements the HchbPatientDetailsDocuments interface.
 */
export function instanceOfHchbPatientDetailsDocuments(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HchbPatientDetailsDocumentsFromJSON(json: any): HchbPatientDetailsDocuments {
    return HchbPatientDetailsDocumentsFromJSONTyped(json, false);
}

export function HchbPatientDetailsDocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsDocuments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'generated_documents': !exists(json, 'generated_documents') ? undefined : ((json['generated_documents'] as Array<any>).map(HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSON)),
        'screener_documents': !exists(json, 'screener_documents') ? undefined : ((json['screener_documents'] as Array<any>).map(DocumentFromJSON)),
        'additional_documents': !exists(json, 'additional_documents') ? undefined : ((json['additional_documents'] as Array<any>).map(HchbPatientDetailsDocumentsAdditionalDocumentsInnerFromJSON)),
    };
}

export function HchbPatientDetailsDocumentsToJSON(value?: HchbPatientDetailsDocuments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'generated_documents': value.generated_documents === undefined ? undefined : ((value.generated_documents as Array<any>).map(HchbPatientDetailsDocumentsGeneratedDocumentsInnerToJSON)),
        'screener_documents': value.screener_documents === undefined ? undefined : ((value.screener_documents as Array<any>).map(DocumentToJSON)),
        'additional_documents': value.additional_documents === undefined ? undefined : ((value.additional_documents as Array<any>).map(HchbPatientDetailsDocumentsAdditionalDocumentsInnerToJSON)),
    };
}

